
(function(textEditor) {
    

publishingApp.directive('textEditor', ['$document', '$window', '$compile', function($document, $window, $compile) {
    return {
        restrict: 'A',
        scope: false,
        link: function (scope, element, attrs) {


                element.bind('click', function (element) {
                    if(element.target.className === 'icon-bold'){
                        //setTimeout(function(){

                            document.execCommand('bold', false, null);
                        //},10);

                        //$('.component ').each(function(index){
                        //    if($(this).attr('id') === $(element).attr('id')){
                        //        scope.list[index].styles.bold = 'true';
                        //    }
                        //});
                    }
                    if(element.target.className === 'icon-underline'){
                        event.stopPropagation();
                        document.execCommand('underline', false, null);
                    }
                    if(element.target.className === 'icon-strikethrough'){
                        event.stopPropagation();
                        document.execCommand('strikeThrough', false, null)
                    }
                    if(element.target.className === 'icon-italic'){
                        event.stopPropagation();
                        document.execCommand('italic', false, null);
                    }
                    if(element.target.className === 'icon-superscript'){
                        event.stopPropagation();
                        document.execCommand('superscript', false, null);
                    }
                    if(element.target.className === 'icon-subscript'){
                        event.stopPropagation();
                        document.execCommand('subscript', false, null);
                    }
                    if(element.target.className === 'icon-link'){
                        event.stopPropagation();
                        var linkUrl = prompt('Enter the URL: '); //To be replaced by $scope... When modal is designed
                        document.execCommand('createLink', false, linkUrl);
                    }
                });
            
        }
    }
}]);
}('textEditor'));




